import React from 'react'
import { Dialog, DialogActions, DialogContent, Divider, IconButton } from '@mui/material'
import { Close } from '@mui/icons-material'

import { Button } from '../button'
import { Text } from '../text'
import { color } from '../../theme'

export interface AlertDialogProps {
  open: boolean
  title: string
  buttonText?: string
  message: string
  onClose: () => void
}

export function AlertDialog(props: AlertDialogProps) {
  const { open, title, buttonText, message, onClose } = props

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog maxWidth="xs" aria-labelledby="confirmation-dialog-title" open={open}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: 20,
          paddingTop: 10,
          paddingBottom: 10,
          minWidth: 440,
        }}
      >
        <Text variant="body1Emphasized" text={title} />
        <IconButton onClick={() => handleClose()} size="large">
          <Close htmlColor={color.shade50} style={{ fontSize: 22 }} />
        </IconButton>
      </div>

      <Divider />

      <DialogContent>
        <Text
          variant="body1Medium"
          text={message}
          style={{ marginTop: 32, marginBottom: 50, textAlign: 'center' }}
        />
      </DialogContent>
      <DialogActions style={{ paddingRight: 20, paddingBottom: 20, paddingLeft: 20 }}>
        <Button disableElevation onClick={handleClose} text={buttonText ? buttonText : 'Close'} />
      </DialogActions>
    </Dialog>
  )
}
